// extracted by mini-css-extract-plugin
export default {"title":"Navigation_title__zTbXp","buttonsContainer":"Navigation_buttonsContainer__LRcT0","button":"Navigation_button__Gk5aZ","icon":"Navigation_icon__ujqEJ"};